import React, { useCallback, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";
import { useNavigationBar } from "../../../context/NavigationContext";
import { ContentState, SKDocumentArtifact } from "../../../models/SKArtifact";
import "react-datepicker/dist/react-datepicker.css";
import DocumentInput from "./DocumentInput";
import * as Yup from "yup";
import { AddTextField } from "../../../components/AddTextField";
import { isEditable } from "@testing-library/user-event/dist/utils";
import { FolderName } from "../../../api/shared/uploadService";

export default function AddDocument() {
  const { contentData, artifactId, updateContentData, loading, saveData, isEditable } = useContext(CreateArtifactContext);
  const { setNavProps } = useNavigationBar();
  const navigate = useNavigate();
  const [isValidForm, setIsValidForm] = useState(false);
  const [documentData, setDocumentData] = useState<SKDocumentArtifact | undefined>(undefined);

  const schema = Yup.object().shape({
    documentPath: Yup.string().required(),
    documentName: Yup.string().required().max(50),
  });

  useEffect(() => {
    const validate = async () => {
      try {
        await schema.validate(contentData, { abortEarly: false });
        setIsValidForm(true);
      } catch (err) {
        setIsValidForm(false);
      }
    };
    validate();
  }, [contentData, schema]);

  useEffect(() => {
    setNavProps(prev => ({
      ...prev,
      backArrow: false,
      buttonTitle: "Done",
      title: "Add Document",
      getActionItems: undefined,
      enableLink: isEditable ? isValidForm : false,
      onNext: isEditable ? submit : undefined,
      onClose: () => navigate(-1),
      onEdit: undefined,
    }));
  }, [setNavProps, documentData, isEditable]);

  useEffect(() => {
    setDocumentData(contentData as SKDocumentArtifact);
  }, [contentData]);

  const submit = async () => {
    await saveData();
    window.history.back();
  };

  const handleFileChange = useCallback(
    (fileUrl: string | null) => {
      // if (fileUrl) {
      updateContentData({ documentPath: fileUrl });
      // } else {
      //   const { documentPath, ...rest } = contentData as SKDocumentArtifact;
      //   // const { documentName, ...restName } = contentData as SKDocumentArtifact;
      //   updateContentData(rest);
      // }
    },
    [updateContentData, contentData]
  );

  return (
    <>
      <div className="flex flex-col gap-[30px] mt-[12px]">
        <div>
          {" "}
          {artifactId ? (
            <>
              <div>
                <div className="flex items-center">
                  <span>
                    <span className="content_count">1</span>
                  </span>
                  <span className="content_title">Add Document</span>
                </div>
                <div className="notes-class-content">Maximum file size of 100MB.</div>
                <DocumentInput
                  docId={artifactId!}
                  onFileChange={handleFileChange}
                  documentUrl={documentData?.documentPath}
                  maxFileSize={10}
                  editable={isEditable}
                  folder={FolderName.content}
                />
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
        <div>
          <AddTextField
            name={"documentname"}
            title={"Add Document Name"}
            note={"Name that explains the topic, purpose or title of the document."}
            placeholder={"Document Name"}
            index={2}
            charAllowed={150}
            value={documentData?.documentName}
            onChange={async e => {
              updateContentData({
                documentName: e.target.value,
              });
            }}
            disabled={!isEditable}
          />
        </div>
      </div>
    </>
  );
}
